export const RENTAL_TYPE = {
  STANDARD: 1,
  DELIVERY: 2,
  NULL: null
};
